/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Membership = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.25 4.25H23.25V20.25H1.25V4.25ZM2.75 5.75V18.75H21.75V5.75H2.75Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.59367 16.4343C6.03613 16.4343 4.25 14.7515 4.25 12.3422C4.25 11.1274 4.67911 10.0878 5.49112 9.33608C6.24739 8.63565 7.27756 8.25 8.39195 8.25C8.94969 8.25 9.42586 8.34612 9.8869 8.43912C10.327 8.52805 10.7427 8.61191 11.2054 8.61191C11.3428 8.61191 11.4747 8.60467 11.6078 8.58984V10.4052C11.4456 10.4282 11.2885 10.4394 11.1279 10.4394C10.6135 10.4394 10.1858 10.3192 9.77204 10.2028C9.37185 10.0908 8.99392 9.98489 8.56014 9.98489C7.22182 9.98489 6.28713 10.9206 6.28713 12.2602C6.28713 13.6677 7.31188 14.6506 8.77903 14.6506C9.69643 14.6506 10.7259 14.2618 11.6078 13.5831V15.478C11.0125 15.9152 10.0077 16.4343 8.59367 16.4343Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.25 10H14.25V8.5H20.25V10Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.25 13H14.25V11.5H20.25V13Z"
                        fill={color}
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.25 16H14.25V14.5H20.25V16Z"
                        fill={color}
                    />
                </svg>
        );
    };
